export default "__VITE_ASSET__DWL7Pi7H__"